/**
 * Messages for failed sign-in, recovery and sign-out requests (shared sign-in plan
 * 2026-10-09, lighter Mobili scope). Same wording as MobiliHD. Never throws, so a
 * dropped connection or an unreadable answer cannot leave a screen stuck loading.
 */

export const AUTH_REQUEST_TIMEOUT_MS = 20000;

export const AUTH_COPY = {
	wrongCredentials: 'El correo o la contraseña no son correctos.',
	noConnection: 'No pudimos conectarnos. Revisa tu conexión e inténtalo de nuevo.',
	timeout: 'La conexión está tardando demasiado. Inténtalo de nuevo.',
	server: 'Tuvimos un problema. Inténtalo de nuevo en unos minutos.',
	tooManyAttempts: 'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
	invalidLink: 'Este enlace ya no es válido. Los enlaces sirven una sola vez y vencen a los 15 minutos.',
	logoutUnconfirmed: 'Cerraste sesión en este equipo, pero no pudimos confirmarlo con el servidor. La sesión vencerá automáticamente.'
};

const API_WRONG_CREDENTIALS = 'Credenciales inválidas';

const escapeHtml = (value) => String(value)
	.replace(/&/g, '&amp;')
	.replace(/</g, '&lt;')
	.replace(/>/g, '&gt;')
	.replace(/"/g, '&quot;')
	.replace(/'/g, '&#39;');

export const tooManyAttemptsMessage = (retryAfterSeconds) => {
	const seconds = Number.parseInt(retryAfterSeconds, 10);
	if (!Number.isFinite(seconds) || seconds <= 0) {
		return AUTH_COPY.tooManyAttempts;
	}
	if (seconds >= 90) {
		return `Demasiados intentos. Espera ${Math.ceil(seconds / 60)} minutos e inténtalo de nuevo.`;
	}
	return `Demasiados intentos. Espera ${seconds} ${seconds === 1 ? 'segundo' : 'segundos'} e inténtalo de nuevo.`;
};

const listOf = (messages) => (
	`<ul class="list-group border-0 bg-transparent">${messages
		.map((message) => `<li class="border-0 d-flex text-start">${escapeHtml(message)}</li>`)
		.join('')}</ul>`
);

/**
 * Turn an axios error into { kind, html }. kind is one of: timeout, network,
 * rate_limit, rejected, validation, unauthenticated, server.
 */
export const describeAuthError = (error) => {
	if (error && error.code === 'ECONNABORTED') {
		return { kind: 'timeout', html: escapeHtml(AUTH_COPY.timeout) };
	}
	const response = error && error.response;
	if (!response) {
		return { kind: 'network', html: escapeHtml(AUTH_COPY.noConnection) };
	}
	const { status, data, headers } = response;
	if (status === 429) {
		return { kind: 'rate_limit', html: escapeHtml(tooManyAttemptsMessage(headers && headers['retry-after'])) };
	}
	if (status === 401) {
		return { kind: 'unauthenticated', html: '' };
	}
	const errors = data && typeof data === 'object' ? data.errors : null;
	if (status === 422 && Array.isArray(errors) && typeof errors[0] === 'string') {
		const message = errors[0] === API_WRONG_CREDENTIALS ? AUTH_COPY.wrongCredentials : errors[0];
		return { kind: 'rejected', html: escapeHtml(message), message };
	}
	if (status === 422 && errors && typeof errors === 'object') {
		const messages = Object.values(errors).flat().map(String);
		return { kind: 'validation', html: listOf(messages) };
	}
	return { kind: 'server', html: escapeHtml(AUTH_COPY.server) };
};
